var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n    From: "+_vm._s(_vm.bindSalePerson())+" "),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.hotel.name))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.bindHotelInfo)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }